export default {
  rounded: {
    borderRadius: 3,
    '&.MuiCard-root': {
      borderRadius: 5,
    },
  },
};
